const VisitsEndpoints = {
  GetVisitsPagedFilter: 'registration_issurance_visit/api/Visit/GetVisitsPagedFilter',
  GetDraftVisitPagedFilter:
    'registration_issurance_visit/api/DraftVisit/GetAssignedDraftVisitPagedFilter',
  GetVisitById: 'registration_issurance_visit/api/Visit/GetVisitById',
  GetDraftVisitById: 'registration_issurance_visit/api/DraftVisit/GetDraftVisitById',
  GetVisitDeliberatelyData: 'registration_issurance_visit/api/Visit/GetVisitDeliberatelyData',
  GetVehicleVisitingPoints:
    'registration_issurance_visit/api/VehicleVisitingPoint/GetAllVehicleVisitingPoint',
  GeVehicleOptions: 'registration_issurance_visit/api/VehicleOption/GetAllVehicleOption',
  GetCarPriceEstimator:
    'registration_issurance_visit/api/CarPriceEstimator/GetCarPriceEstimatorResult',
  GetEstimatedPriceOfBodyInsurance:
    'registration_issurance_visit/api/CoreInsurance/CalculationOfBodyInsuranceAmount',
  GetLicensePlateInquiry: 'registration_issurance_visit/api/CoreInsurance/GetLicensePlateInquiry',
  ValidateLegalCustomer: 'registration_issurance_visit/api/LegalCustomer/ValidateLegalCustomer',
  ValidateLegalCustomerById:
    'registration_issurance_visit/api/LegalCustomer/ValidateLegalCustomerByNationalId',
  GetCivilRegistryConfirmation:
    'registration_issurance_visit/api/CoreInsurance/CivilRegistryConfirmation',
  GetUploadLink: 'registration_issurance_visit/api/EnterpriseServiceBus/GetUploadLink',
  UploadVisitFile: 'registration_issurance_visit/api/VisitFile/UploadFile',
  UploadVisitBigFile: 'registration_issurance_visit/api/VisitFile/UploadBigFile',
  DownloadVisitFile: 'registration_issurance_visit/api/VisitFile/DownloadFile?id=',
  DownloadThumbnailFile: 'registration_issurance_visit/api/VisitFile/DownloadThumbnailFile?id=',
  GetDownloadLink:
    'registration_issurance_visit/api/EnterpriseServiceBus/GetDownloadLink?HashFile=',
  GetFileContent: 'registration_issurance_visit/api/VisitFile/GetFileContent?id=',
  CreateVisit: 'registration_issurance_visit/api/Visit/CreateVisit',
  CompletePendingVisit: 'registration_issurance_visit/api/Visit/CompletePendingVisit',
  CreateTemporaryVisits: 'registration_issurance_visit/api/TemporaryVisit/CreateTemporaryVisit',
  GetVisitSummaryReportPdfFile:
    'registration_issurance_visit/api/Visit/GetVisitSummaryReportPdfFile?VisitId=',
  ConvertGeocodingToAddress: 'registration_issurance_visit/api/Podium/ConvertGeocodingToAddress',
  GetPlateInformationFromImageIds:
    'registration_issurance_visit/api/Podium/GetPlateInformationFromImageIds',
  UpdateVisit: 'registration_issurance_visit/api/Visit/UpdateDipVisit',
  GetVisitForUpdate: 'registration_issurance_visit/api/Visit/GetDipVisitForUpdate',
  GetAllPlateSerial: 'registration_issurance_visit/api/PlateSerial/GetAllPlateSerial',
  GetAllWithVehicleTypes:
    'registration_issurance_visit/api/CargoCompartment/GetAllWithVehicleTypes',
  GetPlateSerialPagedFilter:
    'registration_issurance_visit/api/PlateSerial/GetPlateSerialPagedFilter',

  GetAllVehicleTypes: 'registration_issurance_visit/api/VehicleType/GetAllVehicleType',
  GetAllVehicleBrands: 'registration_issurance_visit/api/VehicleBrand/GetAllVehicleBrand',
  GetAllVehicleTips: 'registration_issurance_visit/api/VehicleTip/GetAllVehicleTip',
  GetAllVehicleColors: 'registration_issurance_visit/api/VehicleColor/GetAllVehicleColor',
  GetAllVehicleUsages: 'registration_issurance_visit/api/VehicleUsage/GetAllVehicleUsage',
  GetAllAutoParts: 'registration_issurance_visit/api/AutoPart/GetAllAutoPart',
  GetAllVehicleAccessories:
    'registration_issurance_visit/api/VehicleAccessory/GetAllVehicleAccessory',
  GetAllMainBodyInsuranceCoverages:
    'registration_issurance_visit/api/MainBodyInsuranceCoverage/GetAllMainBodyInsuranceCoverage',
  GetAllAdditionalBodyInsuranceCoverages:
    'registration_issurance_visit/api/AdditionalBodyInsuranceCoverage/GetAllAdditionalBodyInsuranceCoverage',
  GetAllStates: 'registration_issurance_visit/api/State/GetAllState',
  GetAllCities: 'registration_issurance_visit/api/City/GetAllCity',
  GetAllInsuranceTypes: 'registration_issurance_visit/api/InsuranceType/GetAllInsuranceType',
  GetVisitRequestPagedFilter:
    'registration_issurance_visit/api/VisitRequest/GetVisitRequestPagedFilter',
  GetVisitRequestById: 'registration_issurance_visit/api/VisitRequest/GetVisitRequestById',
  GetVisitRequestByNotificationId: 'registration_issurance_visit/api/VisitRequest/GetVisitRequestByNotificationId',

  SetAssignVisitRequestCancelledByExpert:
    'registration_issurance_visit/api/VisitRequest/SetAssignVisitRequestCancelledByExpert',
  GetInsuranceExpertFieldsPagedFilter:
    'registration_issurance_visit/api/Expert/GetInsuranceExpertFieldPagedFilter',

  GetExpertsRIVInsuranceUnitById:
    'registration_issurance_visit/api/RIVInsuranceUnit/GetExpertsRIVInsuranceUnitById?Id=',

  GetRIVInsuranceUnitsPagedFilter:
    'registration_issurance_visit/api/RIVInsuranceUnit/GetRIVInsuranceUnitPagedFilter',
  ReferDraftVisitByExpert: 'registration_issurance_visit/api/DraftVisit/ReferDraftVisitByExpert',
  GetAllCountry: 'registration_issurance_visit/api/Country/GetAllCountry',
  SetAssignVisitRequestAccepted:
    'registration_issurance_visit/api/VisitRequest/SetAssignVisitRequestAccepted',
  SetAssignVisitRequestRejected:
    'registration_issurance_visit/api/VisitRequest/SetAssignVisitRequestRejected',
}

export default VisitsEndpoints
